<div class="hygiene-filters">
  <div class="hygiene-filters-row">
    <app-search-box
      class="filters-search"
      (textOnSelection)="searchSubmitted($event)"
      [placeholder]="'hygienePage.filters.search' | labelsProvider"
      [startingValue]="pageFilters.search.getFilterValue()"
      [newValueTriggered$]="searchBoxNewValue"
      [syncValidators]="searchValidators"
    >
    </app-search-box>
    <app-date-picker
      class="filters-date-picker"
      (dateOnSelection)="fromDateSelected($event)"
      label="tableActionsAndFilters.firstSeenSinceDate"
      [startingValue]="pageFilters.fromDate.getFilterValue()"
      [newValueTriggered$]="fromDateNewValue"
      [maxDate]="pageFilters.toDate.getFilterValue()"
    >
    </app-date-picker>
    <app-date-picker
      class="filters-date-picker"
      (dateOnSelection)="toDateSelected($event)"
      label="tableActionsAndFilters.firstSeenUntilDate"
      [startingValue]="pageFilters.toDate.getFilterValue()"
      [newValueTriggered$]="toDateNewValue"
      [minDate]="pageFilters.fromDate.getFilterValue()"
    >
    </app-date-picker>
  </div>
  <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
